import main from '../assets/images/main.svg';
import Wrapper from '../assets/wrappers/LandingPage';
import { Logo } from '../components';
import { Link } from 'react-router-dom';
const Landing = () => {
  return (
    <Wrapper>
      <nav>
        <Logo />
      </nav>

      <div className='container page'>
        {/* info */}
        <div className='info'>
          <h1>
            job <span>tracking</span> app
          </h1>
          <p>
            Jobster is a powerful online job search platform that connects job
            seekers with potential employers. It offers a user-friendly
            interface that allows job seekers to search for jobs based on
            various criteria, such as location, industry, and experience level.
            Jobster also provides job seekers with personalized job
            recommendations based on their search history and profile
            information. Employers can also use Jobster to post job listings and
            screen potential candidates. With its comprehensive job search
            functionality and cutting-edge AI technology, Jobster is a valuable
            tool for both job seekers and employers alike.
          </p>

          <Link to='/register' className='btn btn-hero'>
            Login/Register
          </Link>
        </div>
        <img src={main} alt='job hunt' className='img main-img' />
      </div>
    </Wrapper>
  );
};

export default Landing;
